<template>
  <div id="app">

        <ArtesVisuais title="Resultado das Matriculas dos Classificados"           
                  subtitle="Vestibular 2020 - EAD"
                  course="Artes Visuais" />

      
  </div>
</template>

<script>
// import Quimica from './components/Quimica.vue'
// import Tabelas from './components/Tabelas.vue'
// import Pedagogia from './components/Pedagogia.vue'
// import Historia from './components/Historia.vue'
// import Geografia from './components/Geografia.vue'
// import EdFisica from './components/EdFisica.vue'
// import CienciasContabeis from './components/CienciasContabeis.vue'
import ArtesVisuais from './components/ArtesVisuais.vue'

export default {
  name: 'App',
  components: {
    // Tabelas, 
    // Quimica,
    // Pedagogia,
    // Historia,
    // Geografia,
    // EdFisica,
    // CienciasContabeis
    ArtesVisuais

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
}
</style>
